// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3eO4d","options":"AnswerScale_options__3oSeE","selected":"AnswerScale_selected__9jmUI"};